import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Col } from '../grid';
import { SelectWrapper } from '../../base';

class DatePicker extends React.Component {
  constructor() {
    super();
    this.state = {
      date: 0,
      month: 0,
      year: 0,
      initialValue: {
        date: null,
        month: null,
        year: null
      }
    };
  }

  componentDidMount() {
    const { value } = this.props;
    this.setDate(value);
  }

  componentWillReceiveProps(nextProps) {
    const { value } = nextProps;
    this.setDate(value);
  }

  setDate = date => {
    const ymd = date.split('-');
    this.setState({
      initialValue: {
        date: { label: ymd[2], value: ymd[2] },
        month: { label: ymd[1], value: ymd[1] },
        year: { label: ymd[0], value: ymd[0] }
      }
    });
  };

  updateValue = (field, val) => {
    const { onChange, onBlur } = this.props;
    this.setState({ [field]: val }, () => {
      onChange(this.getValue());
      onBlur();
    });
  };

  getValue = () => {
    const { date, month, year } = this.state;
    const val = `${year.toString().padStart(4, '0')}-${month
      .toString()
      .padStart(2, '0')}-${date.toString().padStart(2, '0')}`;
    return val;
  };

  render() {
    const { label } = this.props;
    const { initialValue } = this.state;
    return (
      <Grid>
        <Col lg={12} md={12} sm={12}>
          <p style={{ color: '#8691A6' }}>{label}</p>
        </Col>
        <Col lg={4} md={4} sm={12}>
          <SelectWrapper
            placeholder="Date"
            options={[...Array(31).keys()].map(x => ({ label: x + 1, value: x + 1 }))}
            value={initialValue.date}
            onChange={e => this.updateValue('date', e.value)}
          />
        </Col>
        <Col lg={4} md={4} sm={12}>
          <SelectWrapper
            placeholder="Month"
            options={[...Array(12).keys()].map(x => ({ label: x + 1, value: x + 1 }))}
            value={initialValue.month}
            onChange={e => this.updateValue('month', e.value)}
          />
        </Col>
        <Col lg={4} md={4} sm={12}>
          <SelectWrapper
            placeholder="Year"
            options={[...Array(100).keys()].map(x => ({
              label: new Date().getFullYear() - x,
              value: new Date().getFullYear() - x
            }))}
            value={initialValue.year}
            onChange={e => this.updateValue('year', e.value)}
          />
        </Col>
      </Grid>
    );
  }
}

DatePicker.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func
};

DatePicker.defaultProps = {
  value: '',
  label: '',
  onChange: () => 0,
  onBlur: () => 0
};

export default DatePicker;
